<app-dialog-heading [heading]="'Membership Overview'"></app-dialog-heading>

<div *ngIf="policyDTO; else noPolicyData">

  <greydom-info-panel 
    [topic]="policyDTO.status"
    [message]="getStartAndEndDate(policyDTO?.startDate, policyDTO?.endDate)"
    [messageToolTip]="'Policy start and end date for member'"
    [iconClickable]="false"
    >
  </greydom-info-panel>

  <div class="clearfix">
    <!-------------------------------------->
    <!-- Left Section-->
    <!-------------------------------------->

    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO.name" [label]="'Policy Name'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO?.policyholder?.name" [label]="'Policy Holder'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO?.payer?.name" [label]="'Payer Name'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO.broker ? (policyDTO?.broker?.code + ' : ' + policyDTO?.broker?.name) :''"  [label]="'Broker'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO?.policyholderGroup ? (policyDTO?.policyholderGroup?.code + ' : ' + policyDTO?.policyholderGroup?.name) :''"
                               [label]="'Policyholder Group'"></app-content-field>
          </div>
        </div>
      </div>
    </div>

    <!-------------------------------------->
    <!-- Right Section-->
    <!-------------------------------------->

    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO.number" [label]="'Policy Number'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO?.administrator?.name" [label]="'Administrator'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field
              [content]="getStartAndEndDate(policyDTO?.startDate, policyDTO?.endDate)"
              [label]="'Policy Start - End Dates'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="policyDTO.status" [label]="'Current Policy Status'"></app-content-field>
          </div>
        </div>

        <div class="col-12">
        </div>

      </div>
    </div>
  </div>
  <mat-gridt-list>
    <div *ngIf="policyDTO?.policyProductPersonLinks as policyProductPersonLinks"
         class="table-container">
      <table [dataSource]="policyProductPersonLinks" mat-table>
        <ng-container matColumnDef="personName">
          <th *matHeaderCellDef mat-header-cell>Member Name</th>
          <td *matCellDef="let row" mat-cell> {{getPersonFullName(row.insuredPerson)}}</td>
        </ng-container>

        <ng-container matColumnDef="nationalIdNumber">
          <th *matHeaderCellDef mat-header-cell>Member ID Number</th>
          <td *matCellDef="let row"
              [matTooltip]="(row?.insuredPerson?.nationalIdNumber.length > 20 ? row?.insuredPerson?.nationalIdNumber: null)"
              mat-cell>
            {{row?.insuredPerson?.nationalIdNumber | truncateText: {sliceEnd: 20} }}
          </td>
        </ng-container>

        <ng-container matColumnDef="memberAssociation">
          <th *matHeaderCellDef mat-header-cell>Member Association</th>
          <td *matCellDef="let row"
              mat-cell>
            {{row?.insuredPerson?.association?.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="product">
          <th *matHeaderCellDef mat-header-cell>Product</th>
          <td *matCellDef="let row" mat-cell> {{row.product.name}}</td>
        </ng-container>

        <ng-container matColumnDef="startAndEndDate">

          <th *matHeaderCellDef mat-header-cell>Member Start - End Dates</th>
          <td *matCellDef="let row" mat-cell>{{getStartAndEndDate(row?.startDate, row?.endDate)}}</td>
        </ng-container>

        <tr *matHeaderRowDef="policyProductPersonLinksDisplayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: policyProductPersonLinksDisplayedColumns;" mat-row></tr>
      </table>

    </div>
  </mat-gridt-list>
</div>


<ng-template #noPolicyData>
  <div class="text-center">
    <label class="column-label claim-column-label">No policy data</label>
  </div>
</ng-template>
